import { render } from "./TwoInOneCoverPageToggleSwitch.vue?vue&type=template&id=5293496b&scoped=true&ts=true"
import script from "./TwoInOneCoverPageToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./TwoInOneCoverPageToggleSwitch.vue?vue&type=script&lang=ts"

import "./TwoInOneCoverPageToggleSwitch.vue?vue&type=style&index=0&id=5293496b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5293496b"]])

export default __exports__